export const metadata = {
  title: "Venue Spotlight: Hohhot Sports Centre 🔍",
  date: "2025-05-06",
  excerpt: "Hohhot Sports Centre is the venue that will see one country be crowned AFC Champions",
  slug: "venue-spotlight-hohhot-sports-centre",
content: `
Another day - another venue spotlight!

Hohhot Sports Centre was the venue selected to host the AFC Women's Futsal Asian Cup.  

This premier event will not only crown the continental champion but also serve as a qualifier for the 2025 FIFA Women’s Futsal World Cup. 

After just viewing the opening ceremony which preceded the Kick Off between The People's Republic of China and the Australian women's futsal team. What more can be said than that was one of the most technologically advanced pre-match shows we've ever laid our eyes on!

Group Stage Overview

Group A

Australia 🇦🇺
China PR (Hosts) 🇨🇳 
Chinese Taipei 🇹🇼 
Uzbekistan 🇺🇿

Group B

Iran 🇮🇷
Hong Kong 🇭🇰
Philippines 🇵🇭
Vietnam 🇻🇳

Group C

Bahrain 🇧🇭
Indonesia 🇮🇩
Japan 🇯🇵
Thailand 🇹🇭

Only three of the above 12 countries will secure a place in the first ever edition of the Women's Futsal World Cup which will take place in the Philippines later this year. (It is also great to see the nations of Philippines and Australia playing for the first time as well!)

The official format of the tournament will be followed as follows:

If the Philippines progress to the semi-finals of the AFC Women’s Futsal Asian Cup China 2025, the other three semi-finalists will qualify for the FIFA Futsal Women’s World Cup 2025; otherwise, the two finalists and winners of the third-place playoff will qualify.
`
};
  